// extracted by mini-css-extract-plugin
module.exports = {"submitButton":"SearchForm_submitButton__2FMgL","searchIcon":"SearchForm_searchIcon__iIk5P","searchForm":"SearchForm_searchForm__xLX6R"};